// Mock data for Gerüst Sanierung website

export const companyInfo = {
  name: "Gerüst Sanierung",
  fullName: "Gerüst Sanierung – Inh. Robert Recher",
  owner: "Robert Recher",
  foundedYear: 2010,
  valueProp: "Reparatur & Aufbereitung von Gerüstböden – wirtschaftlich, fachgerecht, transparent.",
  region: "Illertal (Sitz) – deutschlandweit & international tätig.",
};

export const contactInfo = {
  postAddress: {
    street: "Griesweg 20",
    city: "88457 Kirchdorf/Iller",
  },
  workshop: {
    street: "Sterngasse 5",
    city: "88481 Balzheim",
    access: "Zufahrt: Brühlweg",
  },
  phone: "+49 (0) 7354 / 91589",
  phoneShort: "+49 7354 91589",
  mobile: "+49 (0) 170 / 935 21 43",
  mobileShort: "+49 170 9352143",
  email: "robertrecher@t-online.de",
  serviceHours: "Mo–Fr nach Vereinbarung",
};

export const navigation = [
  { label: "Leistungen", href: "#leistungen" },
  { label: "Ablauf", href: "#ablauf" },
  { label: "Hinweis", href: "#hinweis" },
  { label: "Über uns", href: "#ueber-uns" },
  { label: "Kontakt", href: "#kontakt" },
];

export const heroData = {
  headline: "Gerüstböden wirtschaftlich instandsetzen.",
  subline: "Aufbereitung & Reparatur von Holz- und Alu-Belägen – klar, sauber, transparent.",
  primaryCta: { label: "Jetzt anfragen", href: "#kontakt" },
  secondaryCta: { label: "Leistungen ansehen", href: "#leistungen" },
};

export const services = [
  {
    id: 1,
    title: "Aufbereitung",
    description: "Grobreinigung und fachgerechte Instandsetzung von Gerüstbelägen für die weitere, wirtschaftliche Nutzung.",
    icon: "Wrench",
  },
  {
    id: 2,
    title: "Reparatur / Teiletausch",
    description: "Austausch beschädigter Komponenten, Einbau benötigter Quersprossen und Erneuerung der Beläge (Holz/Alu) – je nach Zustand.",
    icon: "Settings",
  },
  {
    id: 3,
    title: "Verkauf von Materialien",
    description: "Verkauf von sanierten Gerüstbelägen sowie bedarfsgerechte Lieferung von Gerüstböden und Plattenmaterialien wie Siebdruck-/Sperrholz (BFU 100) und Alu-Profilplatten.",
    icon: "Package",
  },
];

export const processSteps = [
  {
    step: 1,
    title: "Anfrage",
    description: "Erfolgt telefonisch.",
  },
  {
    step: 2,
    title: "Transparenter Vorschlag",
    description: "Auskunft über Machbarkeit, Einschätzung der Kosten, zeitliche Abschätzung der Instandsetzung.",
  },
  {
    step: 3,
    title: "Instandsetzung",
    description: "Grobreinigung, Teiletausch, Belagerneuerung und ggf. Einbau von Quersprossen nach Abstimmung.",
  },
  {
    step: 4,
    title: "Lieferung oder Abholung",
    description: "Wahlweise inklusive Lieferung oder Abholung ab unserer Werkstatt.",
  },
];

export const legalNotice = {
  title: "Wichtiger Hinweis zur Nutzung reparierter Beläge",
  text: `Bei reparierten Gerüstbelägen gelten besondere Rahmenbedingungen: Durch die Reparatur entfällt die ursprüngliche bauaufsichtliche Zulassung; die instandgesetzten Beläge entsprechen nicht mehr den anerkannten Regeln der Technik (DIN 4420) und dürfen nicht als „DIN 4420" gekennzeichnet werden. Für den Einsatz kann eine baurechtliche Zustimmung im Einzelfall erforderlich sein. Es wird keine Haftung/Gewährleistung für von Ihnen selbst oder durch uns reparierte Beläge übernommen. Angebote richten sich ausschließlich an Gewerbetreibende.`,
};

export const aboutData = {
  title: "Über uns",
  text: "Seit 2010 sind wir ein verlässlicher Ansprechpartner für die Reparatur und Aufbereitung von Baugerüstbelägen. Aus dem Illertal heraus unterstützen wir Gerüstbauer und Bauunternehmen in ganz Deutschland und auch international – direkt, pragmatisch und mit einem klaren Blick auf Wirtschaftlichkeit und Sicherheit.",
};

export const footerData = {
  company: {
    name: "Gerüst Sanierung – Inh. Robert Recher",
    address: ["Griesweg 20, 88457 Kirchdorf/Iller", "Werkstatt: Sterngasse 5, 88481 Balzheim (Zufahrt Brühlweg)"],
    contact: ["Tel. +49 (0) 7354 / 91589", "Mobil +49 (0) 170 / 935 21 43", "robert.recher@t-online.de"],
  },
  impressum: {
    title: "Impressum",
    lines: [
      "Anbieter: Robert Recher (Einzelunternehmen)",
      "Inhaltlich Verantwortlicher: Robert Recher",
      "Leistungsart: Reparatur/Aufbereitung von Gerüstbelägen; Verkauf von Gerüstböden/Platten.",
    ],
  },
  legal: {
    title: "Rechtliches",
    lines: [
      "Nutzung reparierter Beläge: siehe Hinweis oben.",
      "Es gilt deutsches Recht. Angebote richten sich an Gewerbetreibende.",
    ],
  },
};
